import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { useTheme } from 'styled-components';
import Icons from '../../../../Elements/Icons';
import { InfoTooltipIcon } from '../../../../Feedback/InfoTooltipIcon';
import { useTableContext } from '../../context';
import { HeadWrapper } from './styled';
export const Head = memo(function Head({ children, className, align, contentType, order, handleChangeOrder, tooltip, dataTestId, }) {
    const { colors } = useTheme();
    const { compact } = useTableContext();
    return (_jsxs(HeadWrapper, { className: className, $align: align, $contentType: contentType, $order: order, $sortable: !!handleChangeOrder, $compact: compact, onClick: handleChangeOrder, role: 'columnheader', "data-testid": dataTestId, children: [handleChangeOrder && (_jsx(Icons.Arrow, { size: 16, color: order ? colors.main : colors.black_1, align: order === 'ASC' ? 'top' : 'bottom' })), children, tooltip && _jsx(InfoTooltipIcon, { tooltip: tooltip })] }));
});
